.formGroup {
  margin-bottom: var(--newsletter-space-1);
}

.formControl {
  display: block;
  width: 100%;
  padding: var(--newsletter-form-padding);
  font-size: var(--newsletter-form-font-size);
  font-weight: normal;
  line-height: var(--newsletter-input-lh);
  color: var(--color-gray-45);
  background-color: var(--color-white);
  background-clip: padding-box;
  transition:
    border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
  height: var(--newsletter-form-height);
  border-radius: 0;
  border: 1px solid var(--color-grey-0);

  &::placeholder {
    opacity: 0.4;
  }
}

.privacy {
  font-family: var(--font-family-lato);
  font-style: normal;
  font-weight: normal;
  font-size: var(--font-xs);
  color: var(--color-bh-black);

  a {
    color: var(--color-bh-dark-blue);
    text-decoration: none;
    background-color: transparent;
  }
}

.btnNewsletter {
  display: inline-block;
  font-weight: normal;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  border: 1px solid transparent;
  padding: var(--newsletter-form-padding);
  font-size: var(--newsletter-form-font-size);
  line-height: var(--newsletter-input-lh);
  transition:
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  background-color: var(--color-blue);
  border-color: var(--color-blue);
  border-radius: 0;
  border-bottom: var(--newsletter-btn-border-bottom);
  color: var(--color-offwhite);
  margin-right: var(--space-xxs);
  cursor: pointer;
}

.alert {
  position: relative;
  padding: var(--newsletter-alert-padding);
  margin-bottom: var(--newsletter-space-1);
  border: 1px solid transparent;
  border-radius: 0.25rem;
  font-size: var(--font-md);

  &.alertSuccess {
    color: var(--color-white);
    background-color: var(--newsletter-alert-success-bg-color);
    border-color: var(--newsletter-alert-success-border-color);

    &:before {
      display: inline-block;
      content: "";
      background-image: url('data:image/svg+xml,<svg class="bi bi-check-box" width="1em" height="1em" viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M15.354 2.646a.5.5 0 010 .708l-7 7a.5.5 0 01-.708 0l-3-3a.5.5 0 11.708-.708L8 9.293l6.646-6.647a.5.5 0 01.708 0z" clip-rule="evenodd"/><path fill-rule="evenodd" d="M1.5 13A1.5 1.5 0 003 14.5h10a1.5 1.5 0 001.5-1.5V8a.5.5 0 00-1 0v5a.5.5 0 01-.5.5H3a.5.5 0 01-.5-.5V3a.5.5 0 01.5-.5h8a.5.5 0 000-1H3A1.5 1.5 0 001.5 3v10z" clip-rule="evenodd"/></svg>');
      background-repeat: no-repeat;
      -webkit-background-size: var(--newsletter-alert-icon-bg-size);
      background-size: var(--newsletter-alert-icon-bg-size);
      background-position: var(--newsletter-alert-icon-bg-position);
      width: var(--newsletter-alert-icon-size);
      height: var(--newsletter-alert-icon-size);
    }
  }

  &.alertError {
    color: var(--color-white);
    background-color: var(--newsletter-alert-error-bg-color);
    border-color: var(--newsletter-alert-error-border-color);

    &:before {
      display: inline-block;
      content: "";
      background-image: url('data:image/svg+xml,<svg class="bi bi-exclamation-triangle" width="1em" height="1em" viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.938 2.016a.146.146 0 00-.054.057L1.027 13.74a.176.176 0 00-.002.183c.016.03.037.05.054.06.015.01.034.017.066.017h13.713a.12.12 0 00.066-.017.163.163 0 00.055-.06.176.176 0 00-.003-.183L8.12 2.073a.146.146 0 00-.054-.057A.13.13 0 008.002 2a.13.13 0 00-.064.016zm1.044-.45a1.13 1.13 0 00-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" clip-rule="evenodd"/><path d="M7.002 12a1 1 0 112 0 1 1 0 01-2 0zM7.1 5.995a.905.905 0 111.8 0l-.35 3.507a.552.552 0 01-1.1 0L7.1 5.995z"/></svg>');
      background-repeat: no-repeat;
      -webkit-background-size: var(--newsletter-alert-icon-bg-size);
      background-size: var(--newsletter-alert-icon-bg-size);
      background-position: var(--newsletter-alert-icon-bg-position);
      width: var(--newsletter-alert-icon-size);
      height: var(--newsletter-alert-icon-size);
    }
  }
}

.tooltipBg {
  background-size: cover;
}

@media (max-width: 992px) {
  .tooltipBg {
    background-image: url("../../../web2-assets/images/TooltipBgMobile.svg");
  }
}

@media (min-width: 993px) {
  .tooltipBg {
    background-image: url("../../../web2-assets/images/TooltipBgDesktop.svg");
  }
}

@media (max-width: 375px) {
  .tooltipBg {
    left: -130px;
  }
}

@media (min-width: 376px) {
  .tooltipBg {
    left: -90px;
  }
}
